import classNames from 'classnames';
import React, {Component, Fragment} from 'react';
import {Card} from 'reactstrap';
import {connect} from 'react-redux';
import myTrainingProgramActionCreators from '../../store/my-training-program/action-creators';
import trainingPhasesActionCreators from '../../store/training-phases/action-creators';
import trainingPhasesSelectors from '../../store/training-phases/selectors';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import Modal from '../../../shared/ui/Modal';
import ObservationPhaseDetail from '../training-phases/ObservationPhaseDetail';
import OrientationPhaseDetail from '../training-phases/OrientationPhaseDetail';
import trainingPhasesReportsActionCreators from "../../store/training-phases/action-creators/training-phase-reports";
import ReportViewSplit from "../reports/ReportViewSplit";
import ModalSplit from "../../../shared/ui/ModalSplit";
import ReportEditSplit from "../reports/ReportEditSplit";
import ScheduledReportAddSplit from "../reports/ScheduleReportAddSplit";
import trainingPhasesActions from "../../store/training-phases/action-creators";

class MyCompletedReports extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedPhaseGuid: null,
      trainingPhaseInitialized: false
    }
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    this.props.loadMyTrainingProgram();
  }

  get isLoading() {
    return (this.props.myTrainingProgram
      || this.props.isLoading.includes('fetchReportsForTrainingPhase')) && !this.state.trainingPhaseInitialized;
  }


  // ----------------------
  // Computed
  // ----------------------

  componentWillReceiveProps(nextProps) {
    if (nextProps.trainingPhases && !this.selectedPhase) {
      let phase = nextProps.trainingPhases.find(tp => tp.status === 'opened');
      if (!phase) {
        phase = nextProps.trainingPhases[nextProps.trainingPhases.length - 1];
      }

      if (phase) {
        this.setState({
          selectedPhaseGuid: phase.guid
        });

        this.props.fetchReportsForTrainingPhase(phase.guid);
      }

      this.setState({
        trainingPhaseInitialized: true
      })
    }
  }

  get selectedPhase() {
    return !this.state.selectedPhaseGuid
      ? null
      : this.props.trainingPhases.find((phase) => {
        return phase.guid === this.state.selectedPhaseGuid;
      });
  }

  get phaseDetailsTitle() {
    return this.selectedPhase && this.selectedPhase.type === 'observation'
      ? `${this.props.myTrainingProgram.getFullName()}: ${
        this.selectedPhase.header
      }`
      : 'Orientation';
  }

  get isAddingScheduledReport() {
    return !!this.props.isAddingScheduledReport;
  }

  // ----------------------
  // Methods
  // ----------------------

  viewPhase(phase) {
    this.setState({
      selectedPhaseGuid: phase.guid
    });

    this.props.fetchReportsForTrainingPhase(phase.guid);
  }

  render() {
    return (
      <LoadingOverlay isLoading={this.isLoading}>
        {!this.isLoading &&
        this.props.myTrainingProgram ? (
            <Fragment>
              <div className="app-content-header">
                <h4 className="title">My Training Program</h4>
              </div>
              <div className="app-content timeline">
                {this.props.trainingPhases &&
                  this.props.trainingPhases
                    .filter(tp => tp.status === 'opened' || tp.status === 'completed')
                    .map(phase => (
                      <button
                        key={phase.guid}
                        className={classNames('button', {
                          primary:
                            this.selectedPhase &&
                            this.selectedPhase.guid === phase.guid,
                          default:
                            !this.selectedPhase ||
                            this.selectedPhase.guid !== phase.guid,
                        })}
                        onClick={() => this.viewPhase(phase)}
                      >
                        {phase.header}
                      </button>
                    ))}
                <Card body>
                  {this.selectedPhase &&
                    this.selectedPhase.type === 'observation' && (
                      <ObservationPhaseDetail phaseGuid={this.state.selectedPhaseGuid} phase={this.selectedPhase} />
                    )}
                  {this.selectedPhase &&
                    this.selectedPhase.type === 'orientation' && (
                      <OrientationPhaseDetail phaseGuid={this.state.selectedPhaseGuid}  phase={this.selectedPhase} />
                    )}
                </Card>
              </div>

              <ModalSplit
                isOpen={this.props.isEditingReportModalOpened}
                onClose={() => this.props.closeEditReport()}
                title={
                  this.props.editingReport && this.props.editingReport.formName
                }
              >
                <ReportEditSplit />
              </ModalSplit>

              <ModalSplit
                isOpen={this.props.isViewingReportModalOpened}
                onClose={() => this.props.closeViewReport()}
                title={this.props.report && this.props.report.formName}
              >
                <ReportViewSplit
                  phase={this.selectedPhase}
                  report={this.props.report}
                />
              </ModalSplit>
              <ModalSplit
                isOpen={this.isAddingScheduledReport}
                onClose={() => this.props.closeAddScheduledReport()}
                title={this.props.form && this.props.form.name}
              >
                <ScheduledReportAddSplit />
              </ModalSplit>
            </Fragment>
          )
          : <h3 className="text-center mt-3">Training not Started</h3>}
      </LoadingOverlay>
    );
  }
}

function mapStateToProps(state) {
  return {
    isEditingReportModalOpened: state.trainingPhases.isEditingReportModalOpened,
    isViewingReportModalOpened: state.trainingPhases.isViewingReportModalOpened,
    isAddingScheduledReport: state.trainingPhases.isAddingScheduledReport,
    myTrainingProgram: state.myTrainingProgram.oit,
    trainingPhases: state.myTrainingProgram.trainingPhases,
    report: trainingPhasesSelectors.viewingReport(state),
    userContext: state.common.userContext,
    isLoading: state.trainingPhases.isLoading
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeViewReport: () => {
      dispatch(trainingPhasesActionCreators.closeViewReport());
    },
    closeEditReport: () => {
      dispatch(trainingPhasesActionCreators.closeEditReport());
    },
    loadMyTrainingProgram: () => {
      return dispatch(myTrainingProgramActionCreators.loadMyTrainingProgram());
    },
    fetchReportsForTrainingPhase: (phaseGuid) => {
      return dispatch(trainingPhasesReportsActionCreators.fetchReportsForTrainingPhase(phaseGuid));
    },
    closeAddScheduledReport: () => {
      dispatch(trainingPhasesActions.closeAddScheduledReport());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyCompletedReports);
